import styled from "styled-components";
import { rem } from "polished";

// icons

const Close = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="15.6772"
      y="14.3932"
      width="1.5"
      height="19.6479"
      transform="rotate(135 15.6772 14.3932)"
      fill="currentColor"
    />
    <rect
      x="1.78418"
      y="15.3405"
      width="1.5"
      height="19.6479"
      transform="rotate(-135 1.78418 15.3405)"
      fill="currentColor"
    />
  </svg>
);

const Min = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="13.3999"
      y="6.57336"
      width="1.5"
      height="12.8"
      transform="rotate(90 13.3999 6.57336)"
      fill="currentColor"
    />
  </svg>
);

const Pause = () => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.166626"
      width="1.5"
      height="11.6667"
      fill="currentColor"
    />
    <rect
      x="4.6665"
      y="0.166626"
      width="1.5"
      height="11.6667"
      fill="currentColor"
    />
  </svg>
);

const Play = () => (
  <svg
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 7L0.5 13.0622L0.500001 0.937822L8 7Z" fill="currentColor" />
  </svg>
);

const Plus = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="6.57312"
      y="0.599976"
      width="1.5"
      height="12.8"
      fill="currentColor"
    />
    <rect
      x="13.3999"
      y="6.57336"
      width="1.5"
      height="12.8"
      transform="rotate(90 13.3999 6.57336)"
      fill="currentColor"
    />
  </svg>
);

const SpeedSlow = () => (
  <svg
    width="26"
    height="10"
    viewBox="0 0 26 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.8418 5.05013C6.8418 5.74154 6.78712 6.35872 6.67774 6.90169C6.57227 7.44466 6.4004 7.9056 6.16212 8.2845C5.92774 8.66341 5.61915 8.95247 5.23633 9.15169C4.85352 9.35091 4.38868 9.45052 3.8418 9.45052C3.1543 9.45052 2.58985 9.27669 2.14844 8.92904C1.70704 8.57747 1.38087 8.07357 1.16993 7.41732C0.95899 6.75716 0.853521 5.9681 0.853521 5.05013C0.853521 4.12435 0.949224 3.33333 1.14063 2.67708C1.33594 2.01693 1.65235 1.51107 2.08985 1.1595C2.52735 0.807941 3.11133 0.63216 3.8418 0.63216C4.5254 0.63216 5.0879 0.807941 5.5293 1.1595C5.97462 1.50716 6.30469 2.01107 6.51954 2.67122C6.73438 3.32747 6.8418 4.12044 6.8418 5.05013ZM2.65235 5.05013C2.65235 5.70247 2.68751 6.24739 2.75782 6.68489C2.83204 7.11849 2.95508 7.44466 3.12696 7.66341C3.29883 7.88216 3.53712 7.99154 3.8418 7.99154C4.14258 7.99154 4.37891 7.88411 4.55079 7.66927C4.72657 7.45052 4.85157 7.12435 4.92579 6.69075C5.00001 6.25325 5.03712 5.70638 5.03712 5.05013C5.03712 4.39779 5.00001 3.85286 4.92579 3.41536C4.85157 2.97786 4.72657 2.64974 4.55079 2.43099C4.37891 2.20833 4.14258 2.097 3.8418 2.097C3.53712 2.097 3.29883 2.20833 3.12696 2.43099C2.95508 2.64974 2.83204 2.97786 2.75782 3.41536C2.68751 3.85286 2.65235 4.39779 2.65235 5.05013ZM7.97266 8.49544C7.97266 8.12825 8.07227 7.87044 8.27149 7.722C8.47462 7.57357 8.71876 7.49935 9.00391 7.49935C9.28126 7.49935 9.51954 7.57357 9.71876 7.722C9.92188 7.87044 10.0234 8.12825 10.0234 8.49544C10.0234 8.847 9.92188 9.10091 9.71876 9.25716C9.51954 9.41341 9.28126 9.49154 9.00391 9.49154C8.71876 9.49154 8.47462 9.41341 8.27149 9.25716C8.07227 9.10091 7.97266 8.847 7.97266 8.49544ZM14.3066 3.86068C14.8301 3.86068 15.2949 3.96029 15.7012 4.1595C16.1113 4.35872 16.4336 4.65169 16.668 5.03841C16.9023 5.42513 17.0195 5.90169 17.0195 6.4681C17.0195 7.08529 16.8906 7.61849 16.6328 8.06771C16.3789 8.51302 15.9981 8.85482 15.4902 9.0931C14.9863 9.33138 14.3574 9.45052 13.6035 9.45052C13.1543 9.45052 12.7305 9.41146 12.332 9.33333C11.9375 9.25911 11.5918 9.14388 11.2949 8.98763V7.42318C11.5918 7.57943 11.9473 7.71224 12.3613 7.82161C12.7793 7.92708 13.1719 7.97982 13.5391 7.97982C13.8984 7.97982 14.2012 7.93294 14.4473 7.83919C14.6934 7.74154 14.8789 7.5931 15.0039 7.39388C15.1328 7.19075 15.1973 6.93294 15.1973 6.62044C15.1973 6.20247 15.0566 5.88216 14.7754 5.6595C14.4941 5.43685 14.0625 5.32552 13.4805 5.32552C13.2578 5.32552 13.0254 5.347 12.7832 5.38997C12.5449 5.43294 12.3457 5.47591 12.1856 5.51888L11.4648 5.13216L11.7871 0.766926H16.4336V2.30208H13.375L13.2168 3.98372C13.3496 3.95638 13.4941 3.92904 13.6504 3.90169C13.8066 3.87435 14.0254 3.86068 14.3066 3.86068ZM25.5801 9.33333H23.5059L21.5137 6.0931L19.5215 9.33333H17.5762L20.418 4.91536L17.7578 0.766926H19.7617L21.6074 3.84896L23.418 0.766926H25.375L22.6856 5.01497L25.5801 9.33333Z"
      fill="currentColor"
    />
  </svg>
);

const SpeedNormal = () => (
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.52149 9.33333H2.71094V4.3763C2.71094 4.23958 2.7129 4.07161 2.7168 3.87239C2.72071 3.66927 2.72657 3.46224 2.73438 3.2513C2.74219 3.03646 2.75001 2.8431 2.75782 2.67122C2.71485 2.722 2.62696 2.80989 2.49415 2.93489C2.36524 3.05599 2.24415 3.16536 2.13087 3.26302L1.14649 4.05404L0.273443 2.96419L3.03321 0.766926H4.52149V9.33333ZM14.4356 9.33333H12.3613L10.3691 6.0931L8.37696 9.33333H6.43165L9.27344 4.91536L6.61329 0.766926H8.61719L10.4629 3.84896L12.2734 0.766926H14.2305L11.541 5.01497L14.4356 9.33333Z"
      fill="currentColor"
    />
  </svg>
);

const SpeedFast = () => (
  <svg
    width="15"
    height="10"
    viewBox="0 0 15 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.03902 9.33337H0.0507412V8.07361L2.20113 5.89978C2.83785 5.24744 3.25387 4.79626 3.44918 4.54626C3.64449 4.29236 3.78512 4.05798 3.87105 3.84314C3.95699 3.6283 3.99996 3.40564 3.99996 3.17517C3.99996 2.83142 3.90426 2.57556 3.71285 2.40759C3.52535 2.23962 3.2734 2.15564 2.95699 2.15564C2.62496 2.15564 2.30269 2.23181 1.99019 2.38416C1.67769 2.5365 1.35152 2.7533 1.01168 3.03455L0.0273037 1.86853C0.449179 1.50916 0.798788 1.25525 1.07613 1.10681C1.35348 0.958374 1.65621 0.845093 1.98433 0.766968C2.31246 0.684937 2.67965 0.643921 3.0859 0.643921C3.62105 0.643921 4.09371 0.741577 4.50387 0.93689C4.91402 1.1322 5.23238 1.40564 5.45894 1.7572C5.68551 2.10876 5.79879 2.51111 5.79879 2.96423C5.79879 3.35876 5.72848 3.72986 5.58785 4.07751C5.45113 4.42126 5.23629 4.77478 4.94332 5.13806C4.65426 5.50134 4.14254 6.01892 3.40816 6.6908L2.3066 7.72791V7.80994H6.03902V9.33337ZM14.4296 9.33337H12.3554L10.3632 6.09314L8.37105 9.33337H6.42574L9.26754 4.91541L6.60738 0.766968H8.61129L10.457 3.849L12.2675 0.766968H14.2246L11.5351 5.01501L14.4296 9.33337Z"
      fill="currentColor"
    />
  </svg>
);

const Filter = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3"
      y="19.5"
      width="1.2"
      height="19"
      transform="rotate(-180 3 19.5)"
      fill="currentColor"
    />
    <rect
      x="10"
      y="19.5"
      width="1.2"
      height="19"
      transform="rotate(-180 10 19.5)"
      fill="currentColor"
    />
    <rect
      x="17"
      y="19.5"
      width="1.2"
      height="19"
      transform="rotate(-180 17 19.5)"
      fill="currentColor"
    />
    <circle
      cx="9.5"
      cy="14.5"
      r="1.9"
      transform="rotate(90 9.5 14.5)"
      fill="#333333"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <circle
      cx="2.5"
      cy="6.5"
      r="1.9"
      transform="rotate(90 2.5 6.5)"
      fill="#333333"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <circle
      cx="16.5"
      cy="8.5"
      r="1.9"
      transform="rotate(90 16.5 8.5)"
      fill="#333333"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

const StyledButton = styled.button`
  ${({ theme, $isSmall = false, $play = false, $active = false }) => `
    background-color: ${
      $active ? theme.color.key.default : theme.color.key.dark
    };
    color: ${theme.color.key.white};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${$isSmall ? rem(24) : rem(32)};
    height: ${$isSmall ? rem(24) : rem(32)};
    border: 0;
    ${$play ? `padding-left: ${rem(8)};` : ""}

    &:hover {
        background-color: ${theme.color.key.default};
    }
  `}
`;

const Icon = ({ id }) => {
  switch (id) {
    case "close":
      return <Close />;
    case "min":
      return <Min />;
    case "pause":
      return <Pause />;
    case "play":
      return <Play />;
    case "plus":
      return <Plus />;
    case "speedSlow":
      return <SpeedSlow />;
    case "speedNormal":
      return <SpeedNormal />;
    case "speedFast":
      return <SpeedFast />;
    case "filter":
      return <Filter />;
    default:
      return null;
  }
};

const RoundButton = ({ id, className, style, onClick, active }) => {
  return (
    <StyledButton
      className={className}
      style={style}
      onClick={onClick}
      $isSmall={id === "plus" || id === "min"}
      $play={id === "play"}
      $active={active}
    >
      <Icon id={id} />
    </StyledButton>
  );
};

export default RoundButton;
